<template>
  <div class="header">
    <!-- <div class="max-width row-block">
      <div class="left">
        <div class="function-col" v-if="functionMenu.length">
          <button class="function-button">
            <i class="fa fa-bars icon" aria-hidden="true"></i>
            <span class="text">Function Menu</span>
          </button>
          <div class="function-menu">
            <ul>
              <li v-for="(menu, index) in functionMenu" :key="index">
                <hr>
                <router-link v-if="menu.linkTo" :to="menu.linkTo" class="button">
                  <i class="fa" v-if="menu.icon" :class="menu.icon" aria-hidden="true"></i>
                  <span class="text">{{ menu.title }}</span>
                </router-link>
                <button v-else @click="menuButton('function', menu)" class="button">
                  <i class="fa" v-if="menu.icon" :class="menu.icon" aria-hidden="true"></i>
                  <span class="text">{{ menu.title }}</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="center">
        <router-link class="logo" :to="{ name: 'main' }">
          <span>Global Title</span>
        </router-link>
      </div>
      <div class="right">
        <div class="user-col">
          <button class="user-button">
            <span class="text">{{ isLogin ? user.username : 'User Menu' }}</span>
            <div class="icon-field">
              <div class="images" :class="{ 'login': isLogin }">
                <img v-if="nco(() => user.avatar_url.length > 0, null)" :src="user.avatar_url">
                <span v-else>{{ nco(() => user.realname ? user.realname[0].toUpperCase() : user.username[0].toUpperCase(), '') }}</span>
              </div>
            </div>
          </button>
          <div class="user-menu">
            <div class="menu-block">
              <ul>
                <li v-for="(menu, index) in userMenu" :key="index">
                  <hr>
                  <router-link v-if="menu.linkTo" :to="menu.linkTo" class="button">
                    <i class="fa" v-if="menu.icon" :class="menu.icon" aria-hidden="true"></i>
                    <span class="text">{{ menu.title }}</span>
                  </router-link>
                  <button v-else @click="menuButton('user', menu)" class="button">
                    <i class="fa" v-if="menu.icon" :class="menu.icon" aria-hidden="true"></i>
                    <span class="text">{{ menu.title }}</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { deleteUser } from '../../api'
import nullConditionalOperator from '../../mixins/nullConditionalOperator'
import toastMethods from '../../mixins/toastMethods'
import responsitive from '../../mixins/responsitive'
import loginData from '../../mixins/loginData'

export default {
  mixins: [
    nullConditionalOperator,
    toastMethods,
    responsitive,
    loginData
  ],
  computed: {
    ...mapGetters([
      'isLogin',
      'user'
    ]),
    // static data
    functionMenu () {
      return [
        {
          title: '首頁',
          icon: 'fa-fw fa-file',
          linkTo: { name: 'main' }
        },
        {
          title: 'Index',
          icon: 'fa-fw fa-file',
          linkTo: { name: 'index' }
        }
      ].filter(x =>
        (x.isLogin === undefined || x.isLogin === this.isLogin) &&
        (x.admin === undefined || x.admin === this.user.admin)
      )
    },
    userMenu () {
      return [
        {
          title: '登入',
          icon: 'fa-fw fa-sign-in',
          isLogin: false
        },
        {
          title: '登出',
          icon: 'fa-fw fa-sign-out',
          isLogin: true
        }
      ].filter(x =>
        (x.isLogin === undefined || x.isLogin === this.isLogin) &&
        (x.admin === undefined || x.admin === this.user.admin)
      )
    }
  },
  methods: {
    ...mapActions([
      'setModalAction'
    ]),
    menuButton (type, menu) {
      if (type === 'function') {
        switch (menu.title) {
          default: {
          }
        }
      } else if (type === 'user') {
        switch (menu.title) {
          case '登入': {
            this.loginClick()
            break
          }
          case '登出': {
            this.logoutClick()
            break
          }
          default: {
          }
        }
      }
    },
    loginClick () {
      this.setModalAction({
        action: 'login',
        width: '300px',
        param: {
          route: { ...this.$route }
        }
      })
    },
    async logoutClick () {
      try {
        let config = this.$ls.get('userInfo')
        await deleteUser(config)
        this.setUserData(null)
        this.$router.push({ name: 'main' })
        this.addToast('success', '登出成功')
      } catch (error) {
        this.setLoginAction(true)
        this.addToast('error', !error.response ? error.message : error.response.data.errors[0])
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/header.vue